import { render, staticRenderFns } from "./select-duoxuan.vue?vue&type=template&id=12b5a7f8&scoped=true&"
import script from "./select-duoxuan.vue?vue&type=script&lang=ts&"
export * from "./select-duoxuan.vue?vue&type=script&lang=ts&"
import style0 from "./select-duoxuan.vue?vue&type=style&index=0&id=12b5a7f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5a7f8",
  null
  
)

export default component.exports